module.exports = __webpack_public_path__ + "img/fail.3ec5cf0c.png";